import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  [data-role=\'droplistContent\'] {\n    ', ';\n  }\n'], ['\n  [data-role=\'droplistContent\'] {\n    ', ';\n  }\n']);

import styled from 'styled-components';

export default styled.div(_templateObject, function (_ref) {
  var maxHeight = _ref.maxHeight;
  return maxHeight ? 'max-height: ' + maxHeight + 'px' : '';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/layer/dist/esm/styledContentContainer.js
// module id = 5951
// module chunks = 0